import configData from '../../fields/other/configData';

export const MUTATION_SET_CONFIG_DATA = /* GraphQL */ `
	mutation($input: ConfigDataInput!) {
		setConfigData(input: $input) {
			${configData}
		}
	}
`;
